<template>
  <div class="offcansav-nav d-md-none" :class="{ opened }">
    <ul class="offcansav-nav__list">
      <li class="offcansav-nav__list-item">
        <a
          class="offcansav-nav__link"
          v-scroll-to="{ el: '#begin', offset: -35, onStart: onScrollStart }"
          href="#"
          >Как начать</a
        >
      </li>
      <li class="offcansav-nav__list-item">
        <a
          class="offcansav-nav__link"
          href="#"
          v-scroll-to="{ el: '#tests', offset: -35, onStart: onScrollStart }"
          >Тесты</a
        >
      </li>
      <li class="offcansav-nav__list-item">
        <router-link class="offcansav-nav__link" to="/students">
          Студентам
        </router-link>
      </li>
      <li class="offcansav-nav__list-item">
        <router-link class="offcansav-nav__link" to="/about">
          О нас
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    opened() {
      return this.$store.getters.offCanvasNavState;
    }
  },
  methods: {
    onScrollStart() {
      this.$store.commit('setOffCanvasNavState', false);
    }
  },
  watch: {
    opened() {
      let elClass = document.body.classList;
      const bodyClass = 'offcansav-nav-opened';
      this.opened ? elClass.add(bodyClass) : elClass.remove(bodyClass);
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/modules/offcanvas-nav';
</style>
